enum TipoTemplate {
  Producao = 'Producao',
  Recebimento = 'Recebimento',
}

enum TipoArquivo {
  Pdf_Img = 'Pdf_Img',
  Excel = 'Excel',
}

enum TipoValor {
  Texto = 'Texto',
  Preco = 'Preco',
}

enum TipoCampo {
  Agrupado = 'Agrupado',
  Coluna = 'Coluna',
  ColunaAgrupado = 'ColunaAgrupado',
  Producao = 'Producao',
}

enum PosicaoConteudo {
  MesmaLinha = 'MesmaLinha',
  Abaixo = 'Abaixo',
}

enum AlinhamentoVerticalLinha {
  Top = 'Top',
  Centralizado = 'Centralizado',
}

export {
  TipoTemplate,
  TipoArquivo,
  TipoValor,
  TipoCampo,
  PosicaoConteudo,
  AlinhamentoVerticalLinha
}
